import React from 'react';

interface UsedTranslationsContextType {
  usedTranslations: Record<string, string>;
}

interface UsedTranslationsProviderProps {
  usedTranslations: Record<string, string>;
}

const UsedTranslationsContext =
  React.createContext<UsedTranslationsContextType>({
    usedTranslations: {},
  });

export const UsedTranslationsProvider: React.FC<
  React.PropsWithChildren<UsedTranslationsProviderProps>
> = ({children, usedTranslations}) => {
  return (
    <UsedTranslationsContext.Provider value={{usedTranslations}}>
      {children}
    </UsedTranslationsContext.Provider>
  );
};

export const useUsedTranslations = () =>
  React.useContext(UsedTranslationsContext);
